/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DownloadFromWeblinkParameter } from '../models/download-from-weblink-parameter';
@Injectable({
  providedIn: 'root',
})
class PublicWebLinksService extends __BaseService {
  static readonly PublicWebLinksPostPath = '/weblinks/download/{link}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `PublicWebLinksService.PublicWebLinksPostParams` containing the following parameters:
   *
   * - `parameter`:
   *
   * - `link`:
   *
   * @return OK
   */
  PublicWebLinksPostResponse(params: PublicWebLinksService.PublicWebLinksPostParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.parameter;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/weblinks/download/${encodeURIComponent(String(params.link))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `PublicWebLinksService.PublicWebLinksPostParams` containing the following parameters:
   *
   * - `parameter`:
   *
   * - `link`:
   *
   * @return OK
   */
  PublicWebLinksPost(params: PublicWebLinksService.PublicWebLinksPostParams): __Observable<Blob> {
    return this.PublicWebLinksPostResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

namespace PublicWebLinksService {

  /**
   * Parameters for PublicWebLinksPost
   */
  export interface PublicWebLinksPostParams {
    parameter: DownloadFromWeblinkParameter;
    link: string;
  }
}

export { PublicWebLinksService }